export default __webpack_public_path__ + "static/media/sample-image.1d72c87b.png";